import TextLink from './text-link';

export default TextLink;
